import { fetchApi } from '@/config/axiosSetting.ts';
import { BodyContactInformationOwnerType } from '@/modules/adjusterReportModules/Insurer-information/types/BodyOwnerType';

export const patchBodyOwnerContactInformationQueryFunction = (
  id: string,
  params?: BodyContactInformationOwnerType,
) =>
  fetchApi({
    method: 'PATCH',
    url: `/body/reports/${id}/insurer_information/owner/contact_information/`,
    data: params,
  });
